import { useNodeConnections } from '@xyflow/react';
import { ToolPrimitive } from './primitive';
import { ToolTransform } from './transform';

export interface ToolNodeData extends Record<string, unknown> {
  label?: string;
  toolName?: string;
  toolConfig?: Record<string, unknown>;
  generated?: {
    result?: string;
    status?: 'idle' | 'running' | 'completed' | 'error';
    error?: string;
  };
  model?: string;
  updatedAt?: string;

  // Text output for subsequent nodes
  text?: string;
}

export type ToolNodeProps = {
  type: string;
  data: ToolNodeData;
  id: string;
};

export const ToolNode = (props: ToolNodeProps) => {
  const connections = useNodeConnections({
    id: props.id,
    handleType: 'target',
  });

  const Component = connections.length ? ToolTransform : ToolPrimitive;

  return <Component {...props} title="Tool" />;
};
